import type { PatchNote } from "../types";

export const PATCH_NOTES: PatchNote[] = [
  {
    version: 10,
    date: "08/10/2026",
    news: [
      "No perfil administrador, o menu tem uma nova tela: Exportação Fiscal. É de onde sai, num arquivo só, tudo o que a contabilidade pede do período — as notas fiscais e as notas comerciais juntas, cada uma na sua pasta dentro do arquivo. Antes isso ficava escondido numa aba da tela de Notas Fiscais e trazia só as notas fiscais; as comerciais tinham que ser baixadas uma a uma.",
      "A tela tem atalhos para os períodos do dia a dia — mês passado, este mês, últimos 30 dias e este ano — e dá para escolher levar só um dos dois tipos de nota, se for o caso.",
      "Depois de gerar, a tela diz quantas notas de cada tipo entraram no arquivo. Se alguma nota do período ficou de fora porque o arquivo dela ainda não tinha sido baixado da prefeitura ou da SEFAZ, aparece um aviso explicando o que fazer — em vez de o arquivo sair incompleto sem ninguém perceber.",
    ],
    improvements: [
      "A aba Download por Período saiu da tela de Notas Fiscais, porque virou a tela nova de Exportação Fiscal. As abas de Locações, Formaturas e Manuais continuam no mesmo lugar.",
      "Quando o sistema recusa a geração do arquivo — por exemplo, nenhuma nota encontrada no período —, o aviso agora mostra o motivo real em vez de uma mensagem genérica.",
    ],
  },
  {
    version: 9,
    date: "30/08/2026",
    improvements: [
      "No cadastro de cliente, o campo Número do endereço agora aceita no máximo 10 caracteres. Vale em todas as telas onde se cadastra cliente: a tela de Clientes, o cadastro no meio de um novo aluguel (vendedora e administrador) e o cadastro rápido das formaturas.",
    ],
  },
  {
    version: 8,
    date: "28/08/2026",
    news: [
      "O sistema agora aceita o novo CNPJ com letras. Ao cadastrar um cliente Pessoa Jurídica, o campo de CNPJ passa a aceitar letras além de números (por exemplo 12.ABC.345/01DE-35), e as letras são preenchidas em maiúsculo automaticamente. CNPJs só de números continuam funcionando normalmente.",
      "Em Notas Comerciais, o CPF/CNPJ do comprador também aceita o CNPJ com letras, e o cliente cadastrado continua sendo reconhecido na hora.",
      "A busca por documento (nas telas de Clientes, Aluguéis, Devolução, Notas Fiscais e Notas Comerciais) também encontra os CNPJs com letras, digitando com ou sem pontuação.",
    ],
    improvements: [
      "Na tela de Notas Fiscais, o filtro de cliente virou dois campos separados — um para o nome e outro para o documento. Antes o sistema tentava adivinhar o que tinha sido digitado; agora dá para procurar por parte do CNPJ com letras sem que ele seja confundido com um nome.",
    ],
  },
  {
    version: 7,
    date: "28/08/2026",
    news: [
      "No perfil administrador, o menu tem uma nova tela: Notas Comerciais. É onde se emite a nota do consumidor — informe o valor e a forma de pagamento, e o CPF ou CNPJ só quando o cliente pedir. Se o documento informado for de um cliente já cadastrado, o nome dele aparece na hora, para conferir antes de emitir. Emitida a nota, a tela mostra o número e a chave, e o cupom pode ser aberto ou baixado ali mesmo.",
      "Ainda em Notas Comerciais, uma nota emitida por engano pode ser cancelada em até 30 minutos, escrevendo o motivo. Passado esse prazo o cancelamento não é mais permitido, e a tela avisa quanto tempo resta. Se uma nota ficar sem resposta, o botão de consultar busca a situação atualizada.",
    ],
    improvements: [
      "No perfil administrador, quando uma nota fiscal é recusada, a tela passa a mostrar o motivo em português, no lugar do texto técnico de antes — e o motivo completo aparece ao passar o mouse.",
      "Também na tela de Notas Fiscais, uma nota que ficou com erro agora tem o botão de tentar de novo, sem precisar refazer o aluguel. Para nota avulsa, basta escolher o cliente novamente.",
    ],
  },
  {
    version: 6,
    date: "27/08/2026",
    improvements: [
      "As buscas nos formulários (cliente, contrato, peça, vendedor, tag) ficaram mais leves: ao digitar rápido, o sistema descarta as consultas anteriores em vez de acumular, mostrando sempre o resultado da sua última palavra.",
      "Fechar um formulário ou trocar de tela no meio de um carregamento não deixa mais o sistema trabalhando à toa: as consultas em andamento são interrompidas na hora, poupando dados e evitando resultados desatualizados na próxima tela.",
    ],
    fixes: [
      "Ao criar ou editar uma comissão ou uma formatura, quando o sistema recusa um dado (por exemplo, um campo obrigatório em branco ou um valor inválido), a mensagem aparece direto no campo com problema, em vez de um aviso genérico no canto da tela.",
    ],
  },
  {
    version: 5,
    date: "25/08/2026",
    improvements: [
      "No perfil administrador, criar um aluguel deixou de ser uma janela pequena e virou uma tela inteira dividida em etapas — a mesma experiência que a vendedora já tinha. O tipo (terno ou beca) é escolhido em cartões, um resumo do aluguel acompanha o preenchimento ao lado, e a última etapa mostra tudo para conferir antes de salvar, com atalho para voltar e corrigir qualquer etapa.",
      "Ainda no administrador, sair da tela de novo aluguel com dados preenchidos agora mostra um aviso antes de descartar o que foi digitado.",
    ],
  },
  {
    version: 4,
    date: "23/07/2026",
    news: [
      "A tela de Aluguéis agora tem busca pelo nome do cliente — nos perfis administrador e vendedora. Digite parte do nome e encontre todos os aluguéis daquele cliente.",
      "Na tela de Clientes, o novo botão de visualizar mostra os dados completos do cliente e a lista de aluguéis dele. Clique em um aluguel da lista para abrir os detalhes na tela de Aluguéis.",
    ],
  },
  {
    version: 3,
    date: "23/07/2026",
    fixes: [
      "No perfil administrador, a busca da tela de Aluguéis agora funciona: procurar pelo número do aluguel (ID) encontra o aluguel, e os filtros de tipo (terno/beca) e de status também passam a filtrar a lista de verdade.",
    ],
  },
  {
    version: 2,
    date: "23/07/2026",
    news: [
      "No perfil administrador, a tela de Notas Fiscais agora tem busca pelo número do contrato e pelo cliente (nome ou CPF/CNPJ) — achar a nota de um aluguel ou de um cliente ficou muito mais rápido.",
      "No perfil administrador, os detalhes de um aluguel agora mostram as notas fiscais dele: dá para baixar o PDF ou o XML na hora, ou abrir a tela de Notas Fiscais já filtrada naquele aluguel.",
    ],
    improvements: [
      "Na lista de notas fiscais, cada nota de locação mostra o número do contrato e o nome do cliente, para conferir de quem ela é sem sair da tela.",
    ],
  },
  {
    version: 1,
    date: "17/07/2026",
    news: [
      "Quando o sistema for atualizado, você fica sabendo das novidades por este aviso — ele aparece uma única vez após cada atualização.",
      "No perfil administrador, agora dá para registrar novos pagamentos ao editar um aluguel, sem esperar a retirada — a tela mostra o valor total, o que já foi pago e o restante. Se o aluguel emite nota fiscal, os novos pagamentos geram as notas normalmente.",
    ],
    improvements: [
      "Com o menu lateral aberto, a versão do sistema aparece no rodapé, para facilitar o suporte.",
    ],
  },
];
